import { render, staticRenderFns } from "./Kriszta.vue?vue&type=template&id=3329408a&scoped=true&"
import script from "./Kriszta.vue?vue&type=script&lang=js&"
export * from "./Kriszta.vue?vue&type=script&lang=js&"
import style0 from "./Kriszta.vue?vue&type=style&index=0&id=3329408a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3329408a",
  null
  
)

export default component.exports